import React from "react";
import { Button, IconButton } from "@mui/material";
import { Print, PrintOutlined } from "@mui/icons-material";

const PrintButton = ({
  outlined,
  disabled,
  printButtonText,
  onButtonClick
}) => {
  return !!printButtonText ? (
    <div>
      <Button
        color="primary"
        onClick={onButtonClick}
        disabled={disabled}
        startIcon={outlined ? <PrintOutlined /> : <Print />}
      >
        {printButtonText}
      </Button>
    </div>
  ) : (
    <IconButton
      color="primary"
      onClick={onButtonClick}
      disabled={disabled}
      size="large"
    >
      {outlined ? <PrintOutlined /> : <Print />}
    </IconButton>
  );
};

export default PrintButton;
